import { createContext, useContext, useState } from "react";

type MatchFiltersContextType = {
  selectedMachines?: number[];
  setSelectedMachines?: (machines: number[]) => void;
  selectedPlayers?: number[];
  setSelectedPlayers?: (players: number[]) => void;
  singlesOrDoubles?: ("singles" | "doubles" | "tiebreak")[];
  setSinglesOrDoubles?: (
    formats: ("singles" | "doubles" | "tiebreak")[]
  ) => void;
  pickOrRespond?: ("pick" | "respond")[];
  setPickOrRespond?: (values: ("pick" | "respond")[]) => void;
};

const MatchFiltersContext = createContext<MatchFiltersContextType>({
  selectedMachines: [],
  setSelectedMachines: () => {},
  selectedPlayers: [],
  setSelectedPlayers: () => {},
  singlesOrDoubles: null,
  setSinglesOrDoubles: () => {},
  pickOrRespond: null,
  setPickOrRespond: () => {},
});

export function MatchFiltersProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [selectedMachines, setSelectedMachines] = useState<number[]>([]);
  const [selectedPlayers, setSelectedPlayers] = useState<number[]>([]);
  const [singlesOrDoubles, setSinglesOrDoubles] = useState<
    ("singles" | "doubles" | "tiebreak")[]
  >(["singles", "doubles"]);
  const [pickOrRespond, setPickOrRespond] = useState<("pick" | "respond")[]>([
    "pick",
    "respond",
  ]);

  const matchFilters = {
    selectedMachines,
    setSelectedMachines,
    selectedPlayers,
    setSelectedPlayers,
    singlesOrDoubles,
    setSinglesOrDoubles,
    pickOrRespond,
    setPickOrRespond,
  };

  return (
    <MatchFiltersContext.Provider value={matchFilters}>
      {children}
    </MatchFiltersContext.Provider>
  );
}

export function useMatchFilters() {
  return useContext(MatchFiltersContext);
}
